// removed by extract-text-webpack-plugin
module.exports = {"need-offer-list-comment":"need-offer-list-comment","user-message":"user-message","avatar":"avatar","poster-info":"poster-info","item-comment-header":"item-comment-header","business-message":"business-message","logo":"logo","link-to":"link-to"};


//////////////////
// WEBPACK FOOTER
// ./components/conversations/_list.scss
// module id = ./components/conversations/_list.scss
// module chunks = 0